import { render, staticRenderFns } from "./PETRulesTable.vue?vue&type=template&id=5d1a294d&"
import script from "./PETRulesTable.vue?vue&type=script&lang=js&"
export * from "./PETRulesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports